import { GirisPage } from './../giris/giris';
import { PagesProvider } from './../../providers/pages-provider';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the RaporanasayfaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 
@Component({
  selector: 'page-raporanasayfa',
  templateUrl: 'raporanasayfa.html',
})
export class RaporanasayfaPage {
  menuler=[];
  gunSonu=false;
  constructor(public navCtrl: NavController,
   
     public navParams: NavParams) {
  }

 
  ionViewDidLoad() {
    this.MenuleriGoruntule();
   }
  
 
   menuItemClick(item) {
    
     var pagesProvider = new PagesProvider();
     var componentType = typeof item.PAGE_COMPONENT;
     var component;
     if (componentType === "string")
       component = pagesProvider.components[item.PAGE_COMPONENT];
     else
       component = item.PAGE_COMPONENT;
     if (component == GirisPage) {
     //  this.ortak.storeagePersonelCikar();
     }
     this.navCtrl.push(component);
   }
   MenuleriGoruntule() {
     var pagesProvider = new PagesProvider();
     pagesProvider.menuler().then(a => {
       var sonuc = <any>a;
       
         this.menuler = sonuc.RAPOR_MENU;
       })
     
   }
}



// WEBPACK FOOTER //
// ./src/pages/raporanasayfa/raporanasayfa.ts